import type { AppConfig } from '@shared/types';

export const appConfig: AppConfig = __APP_CONFIG__;
